import Board from "./Components/Board";
import "./Styles/App.css";

function App() {
  return (
    <div className={"App"}>
      <Board />
    </div>
  );
}

export default App;
